import scheduleRule, { ScheduleRule} from '@/rule/models/ScheduleRule';
import WxTemplate from '@/rule/models/WxTemplate';
import {DelayMode} from '@/rule/models/ScheduleDelay';

export interface ScheduleRuleState {
  scheduleRule: ScheduleRule;
  eventDelayMode: DelayMode;
  scheduleRules: ScheduleRule[];
  wxTemplates: WxTemplate[];
  wxTplTemplates: any[];
  wxTplTemplateTip: boolean;
  trendsData: any[];
}

export const scheduleRuleState: ScheduleRuleState = {
  scheduleRules: [],
  eventDelayMode: DelayMode.UseMsg,
  scheduleRule: JSON.parse(JSON.stringify(scheduleRule)),
  wxTemplates: [],
  wxTplTemplates: [],
  trendsData: [],
  wxTplTemplateTip: false,
};
